<template>
   <div>
      <div class="row">
         <!-- Start col -->
         <div class="col-md-12 col-lg-12 col-xl-12">
            <div class="text-center mt-1 mb-2">
                  <!--h4>Bienvenido a la página de Anuncios</h4-->
            </div>
         </div>
         <!-- End col -->
      </div>

      <div class="row">
         <!-- Lista promociones -->
         <advertisement 
            v-for="ad in ads" :key="ad.id"
            :id="ad.id"
            :title="ad.title"
            :content="ad.content"
            :image-url="ad.image"
            :featured="ad.featured"
            :valid-to="ad.valid_to"
         />
         <!-- Fin Lista promociones -->
      </div>

   </div>
</template>

<script>
import Advertisement from "@clients/Advertisement.vue"
import dateHelper from "@mixins/dateHelper"
export default {
   components: {
      Advertisement
   },
   mixins: [dateHelper],
   data() {
      return {
         ads: [],
      }
   },
   async mounted(){
      await this.getAdsList();
   },
   methods: {
      async getAdsList(){
         this.showLoader()
         const res = await this.xget('/anuncios');
         if(res.success){
            this.setAds(res.data);
         }
         this.stopLoader()
      },
      setAds(rawAds){
         this.ads = [];
         rawAds.forEach(ad => {
            this.ads.push({
               id: ad.ID,
               title: ad.Nombre,
               content: ad.Descripcion,
               featured: ad.Destacado,
               image: ad.Url_Imagen,
               valid_to: this.midDateFormat(ad.Fecha_Fin),
            });
         });
      },
   },
   
}
</script>